exports.ASSISTANCE_STATE_REQUESTED = 'requested';

exports.ASSISTANCE_STATE_PENDING = 'pending';

exports.ASSISTANCE_STATE_IN_PROGRESS = 'in_progress';

exports.ASSISTANCE_STATE_FINISHED = 'finished';

exports.ASSISTANCE_STATE_CANCELED_BY_USER = 'canceled_by_user';
